import create from 'zustand'
import { UseFormReturn } from 'react-hook-form'
import { ObjectiveTemplateDto } from '../../../types'

import { NoteInfoInputExtended, TargetTemplateModalState, TargetTemplateModalType } from './types'

const initialValues = {
  isTargetTemplateModalOpened: false,
  targetTemplateModalType: TargetTemplateModalType.unknown,
  currentObjective: null,
  currentComments: [],
  commentFromInput: undefined,
  newTargetTemplateForm: null,
  newTargetTemplateFormErrors: null,
}

export const useTargetTemplateModalStore = create<TargetTemplateModalState>((set) => ({
  ...initialValues,

  openTargetTemplateModal: (targetTemplateModalType: TargetTemplateModalType, objective?: ObjectiveTemplateDto) =>
    set({
      isTargetTemplateModalOpened: true,
      targetTemplateModalType,
      currentObjective: !!objective ? objective : null,
      currentComments: !!objective && !!objective.objectiveNotes && objective.objectiveNotes.length ? objective.objectiveNotes : [],
    }),

  closeTargetTemplateModal: () =>
    set({
      isTargetTemplateModalOpened: false,
    }),

  cleanTargetTemplateModal: () =>
    set({
      newTargetTemplateForm: null,
      newTargetTemplateFormErrors: null,
      targetTemplateModalType: TargetTemplateModalType.unknown,
      currentObjective: null,
      currentComments: [],
      commentFromInput: undefined,
    }),

  setNewTargetTemplateForm: (newTargetTemplateForm: UseFormReturn<ObjectiveTemplateDto>) => set({ newTargetTemplateForm }),

  addComment: (comment: NoteInfoInputExtended) =>
    set((state) => {
      const currentComments = state.currentComments.slice()
      currentComments.push(comment)
      return {
        ...state,
        currentComments,
        commentFromInput: undefined,
      }
    }),

  setCommentFromInput: (commentFromInput: string | undefined) => set({ commentFromInput }),

  removeComment: (id: string, isNewComment = false) =>
    set((state) => {
      const currentComments = state.currentComments.filter((comment) => comment[isNewComment ? 'id' : 'globalId'] !== id)
      return {
        ...state,
        currentComments,
      }
    }),

  editComment: (id: string, text: string) =>
    set((state) => {
      const currentComments = state.currentComments.reduce((acc: Array<NoteInfoInputExtended>, current: NoteInfoInputExtended) => {
        if (current.id === id) {
          acc.push({ ...current, text })
        } else {
          acc.push(current)
        }
        return acc
      }, [])

      return {
        ...state,
        currentComments,
      }
    }),
}))
